import { FC } from 'react'
import styled from 'styled-components'
import { LevelRatingCheckList_ExamSurveyQuestionFragment } from 'generated/graphql'
import QUESTION_SUBJECT_MAP from '@app.feature/exam/gsat2024-2/constants/questionSubjectMap'
import ChoiceQuestionMobile from './ChoiceQuestion.mobile'
import { InputAnswerItemMobileProps } from './InputAnswerItem.mobile'
import InputQuestionMobile from './InputQuestion.mobile'

interface LevelRatingCheckListMobileProps {
  questions: LevelRatingCheckList_ExamSurveyQuestionFragment[]
}

const LevelRatingCheckListMobile: FC<LevelRatingCheckListMobileProps> = ({
  questions,
}) => {
  return (
    <StyledWrapper>
      {questions.map((question, index) => {
        const answerList = question.answer.nodes
        const questionLabel = `${index + 1}. ${question.content}`
        const inputQuestionArray: InputAnswerItemMobileProps[] =
          question.answer.nodes.map((answer) => {
            return {
              answer,
              questionId: question.id,
              questionSeq: question.seq,
              inputQuestionSubject: QUESTION_SUBJECT_MAP[answer.seq],
            }
          })

        return question.isNumericAnswer ? (
          <InputQuestionMobile
            questioonLabel={questionLabel}
            answerList={inputQuestionArray}
            key={question.id}
          />
        ) : (
          <ChoiceQuestionMobile
            questioonLabel={questionLabel}
            answerList={answerList}
            questionSeq={question.seq}
            questionId={question.id}
            key={question.id}
          />
        )
      })}
    </StyledWrapper>
  )
}

export default LevelRatingCheckListMobile

const StyledWrapper = styled.div`
  padding: 32px 24px;
  width: 100%;
  min-height: 300px;
  border-radius: 20px;
  border: solid 1px #e8e8e8e8;
  background-color: #fff;
`
